/* Constants */
import {
  PLATFORMS,
  ROUTE_PATHS,
} from '../../../core/route/routeConstants';

const DAVINCI_EVENT_NAMES = {
  SEARCH_BUTTON_CLICK: 'SearchButtonClick',
  PAGE_LOAD: 'PageLoad',
  PRODUCT_LIST: 'ProductList',
  PRODUCT_CLICK: 'ProductClick',
  ADD_TO_CART_CLICK: 'AddToCartClick',
  PRE_ORDER_CLICK: 'PreorderClick',
  CHANGE_VARIANT: 'ChangeVariant',
  VIEW_VARIANT_LIST: 'ViewVariantList',
  CLOSE_VARIANT_LIST: 'CloseVariantList',
  FEEDBACK_VIEW: 'FeedbackView',
  FEEDBACK_CLICK: 'FeedbackClick',
  SUGGESTIONSBOX_VIEW: 'SuggestionBoxView',
  FILTER_WIDGET_CLICK: 'FilterWidgetClick',
  RECO_PRODUCTS_CLICK: 'RecoProductsClick',
  RECO_PRODUCTS_VIEW: 'RecoProductsView',
  RECO_PRODUCTS_ARROW_CLICK: 'RecoProductsArrowClick',
  LINK_CLICK: 'LinkClick',
  PRODUCT_CAROUSEL_VIEW: 'ProductCarouselView',
  PRODUCT_CAROUSEL_CLICK: 'ProductCarouselClick',
  PRODUCT_CAROUSEL_ARROW_CLICK: 'ProductCarouselArrowClick',
  FILTER_FACET_CLICK: 'FilterFacetClick',
  SORT_CLICK: 'SortClick',
  SMART_FILTER_VIEW: 'SmartFilterView',
  HOME_PAGE_VIEW: 'HomePageView',
  REMOVE_FILTERS: 'RemoveFilters',
  WEB_VITALS: 'WebVitals',
  SPONSORED_PRODUCT_VIEW: 'SponsoredProductView',
  SPONSORED_PRODUCT_CLICK: 'SponsoredProductClick',
  PRODUCT_LIST_VIEW: 'ProductListView',
  TYPO_CORRECTION_VIEW: 'TypoCorrectionView',
  TYPO_CORRECTION_CLICK: 'TypoCorrectionClick',
  BANNER_VIEW: 'BannerView',
  BANNER_CLICK: 'BannerClick',
  IMAGE_VIEW: 'ImageView',
  VIDEO_COMPONENT_VIEW: 'VideoComponentView',
  DISPLAY_VIDEO: 'DisplayVideo',
  BRAND_CLICK: 'BrandClick',
  COMMENT_NUMBER_CLICK: 'CommentNumberClick',
  FIRST_COMMENT_CLICK: 'FirstCommentClick',
  PRODUCT_VIEW: 'ProductView',
  COMPONENT_CLICK: 'ComponentClick',
  COMPONENT_VIEW: 'ComponentView',
  ALL_SELLERS_TAB_CLICK: 'AllSellersTabClick',
  BOTTOM_SHEET_VIEW: 'BottomSheetView',
  DESCRIPTION_TAB_CLICK: 'DescriptionTabClick',
  COMMENT_TAB_CLICK: 'CommentTabClick',
  QUESTION_ANSWER_TAB_CLICK: 'QuestionAnswerTabClick',
  BNPL_TAB_CLICK: 'BNPLTabClick',
  INSTALLMENT_TAB_CLICK: 'InstallmentTabClick',
  LOAN_TAB_CLICK: 'LoanTabClick',
  REFUND_TAB_CLICK: 'RefundTabClick',
  OTHER_MERCHANTS_VIEW: 'OtherMerchantsView',
  OTHER_MERCHANTS_CLICK: 'OtherMerchantsClick',
  VAS_SERVICE_ADDED: 'ValueAddedService',
  CAMPAIGN_CARD_CLICK: 'CampaignCardClick',
  LISTING_OPPORTUNITY_BUTTON: 'ListingOpportunityButton',
  GO_TO_SELLER_CLICK: 'GoToSellerClick',
  VODAFONE_QR_CODE: 'VodafoneQrCode',
  ADD_TO_CART_TOGETHER_CLICK: 'AddToCartTogetherClick',
  IMAGE_LABEL_VIEW: 'ImageLabelView'
};

const DAVINCI_CHANNELS = {
  PWA: 'pwa',
};

const DAVINCI_PAGES = {
  HOME: 'Home',
  CATEGORY: 'Departments',
  CATEGORY_LANDING: 'Dynamic Departments',
  SEARCH: 'Search Results',
  SEARCH_COMBINATION: 'Search Combination',
  TAG: 'Tagged Products',
  CAMPAIGN: 'Campaigns',
  DYNAMIC: 'Dynamic Static',
  DYNAMIC_VIEW: 'Dynamic View',
  STATIC: 'Campaigns',
  BRAND: 'Brand',
  MERCHANT: 'Merchant',
  PRODUCT_DETAIL_PAGE: 'pdp',
  AUTHORS: 'Authors',
  BRANDS: 'Brands',
  PRODUCT_QNA: 'Qna',
  PRODUCT_COMMENT: 'Product Detail Comment',
};

const DAVINCI_PAGE_TYPES = {
  CATEGORY: 'category',
  CATEGORY_LANDING: 'dynamic-departments',
  HOME: 'home',
  SEARCH: 'search',
  SEARCH_COMBINATION: 'search combination',
  TAG: 'taggedproduct',
  CAMPAIGN: 'campaigns',
  DYNAMIC: 'dynamic-static',
  STATIC: 'static',
  BRAND: 'brand',
  MERCHANT: 'merchant',
  PRODUCT_DETAIL_PAGE: 'pdp',
  AUTHORS: 'authors',
  BRANDS: 'brands',
  PRODUCT_QNA: 'qna',
  PRODUCT_COMMENT: 'comment',
};

const DAVINCI_PAGES_BY_ROUTES_DICT = {
  [ROUTE_PATHS[PLATFORMS.MOBILE].HOME_PAGE]: DAVINCI_PAGES.HOME,
  [ROUTE_PATHS[PLATFORMS.MOBILE].CATEGORY_PAGE]: DAVINCI_PAGES.CATEGORY,
  [ROUTE_PATHS[PLATFORMS.MOBILE].BRAND_CATEGORY_PAGE]: DAVINCI_PAGES.CATEGORY,
  [ROUTE_PATHS[PLATFORMS.MOBILE].HURLY_CATEGORY_PAGE]: DAVINCI_PAGES.CATEGORY,
  [ROUTE_PATHS[PLATFORMS.MOBILE].SEARCH_PAGE]: DAVINCI_PAGES.SEARCH,
  [ROUTE_PATHS[PLATFORMS.MOBILE].COLLECTION_PAGE]: DAVINCI_PAGES.SEARCH,
  [ROUTE_PATHS[PLATFORMS.MOBILE].PRODUCT_DETAIL_PAGE]: DAVINCI_PAGES.PRODUCT_DETAIL_PAGE,
  [ROUTE_PATHS[PLATFORMS.MOBILE].TAG_PAGE]: DAVINCI_PAGES.TAG,
};

const DAVINCI_PAGES_BY_LOCATION_DICT = {
  [ROUTE_PATHS[PLATFORMS.MOBILE].HOME_PAGE]: DAVINCI_PAGE_TYPES.HOME,
  [ROUTE_PATHS[PLATFORMS.MOBILE].CATEGORY_PAGE]: DAVINCI_PAGE_TYPES.CATEGORY,
  [ROUTE_PATHS[PLATFORMS.MOBILE].BRAND_CATEGORY_PAGE]: DAVINCI_PAGE_TYPES.CATEGORY,
  [ROUTE_PATHS[PLATFORMS.MOBILE].HURLY_CATEGORY_PAGE]: DAVINCI_PAGE_TYPES.CATEGORY,
  [ROUTE_PATHS[PLATFORMS.MOBILE].SEARCH_PAGE]: DAVINCI_PAGE_TYPES.SEARCH,
  [ROUTE_PATHS[PLATFORMS.MOBILE].COLLECTION_PAGE]: DAVINCI_PAGE_TYPES.SEARCH,
  [ROUTE_PATHS[PLATFORMS.MOBILE].PRODUCT_DETAIL_PAGE]: DAVINCI_PAGES.PRODUCT_DETAIL_PAGE,
  [ROUTE_PATHS[PLATFORMS.MOBILE].TAG_PAGE]: DAVINCI_PAGE_TYPES.TAG,
};

const DAVINCI_LOCATIONS = {
  LISTING: 'Listing',
  VARIANTPOPUP: 'VariantPopUp',
};

const FIRST_RECO_VIEW_PRODUCT_COUNT = 3;

const DAVINCI_RECO_ARROW = {
  RIGHT_SWIPE: 'rightswipe',
  LEFT_SWIPE: 'leftswipe',
}

const DAVINCI_FACET_CLICK = {
  FILTER: 'filter',
  CATEGORY: 'category',
}

const SMART_FILTER = 'AkıllıSıralama';

export {
  DAVINCI_EVENT_NAMES,
  DAVINCI_CHANNELS,
  DAVINCI_PAGES,
  DAVINCI_PAGES_BY_ROUTES_DICT,
  DAVINCI_PAGES_BY_LOCATION_DICT,
  DAVINCI_PAGE_TYPES,
  DAVINCI_LOCATIONS,
  DAVINCI_RECO_ARROW,
  FIRST_RECO_VIEW_PRODUCT_COUNT,
  DAVINCI_FACET_CLICK,
  SMART_FILTER,
};
